<script setup>
import { ref } from "vue";
import { Empty } from "ant-design-vue";

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);
const formModel = ref({});

const handleShow = (record) => {
  formModel.value = Object.assign({}, { ...record });
  console.info("formModel.expectationList", formModel.value.expectationList);
  open.value = true;
};

const handleClose = () => {
  open.value = false;
  formModel.value = Object.assign({});
};

const expectationColumns = [
  {
    key: "workingType",
    dataIndex: "workingType",
    title: "职位类型",
    width: "30%",
  },
  {
    key: "jobTypeName",
    dataIndex: "jobTypeName",
    title: "期望职位",
    width: "30%",
  },
  {
    key: "wage",
    dataIndex: "wage",
    title: "期望薪资",
    width: "30%",
  },
];

const workExperienceColumns = [
  {
    key: "companyName",
    dataIndex: "companyName",
    title: "公司名称",
    width: "10%",
  },
  {
    key: "department",
    dataIndex: "department",
    title: "所属部门",
    width: "10%",
  },
  {
    key: "jobTypeName",
    dataIndex: "jobTypeName",
    title: "职位",
    width: "10%",
  },
  {
    key: "time",
    dataIndex: "time",
    title: "工作时间",
    width: "10%",
  },
  {
    key: "content",
    dataIndex: "content",
    title: "工作内容",
    width: "30%",
  },
  {
    key: "performance",
    dataIndex: "performance",
    title: "工作业绩",
    width: "30%",
  },
];

const projectExperienceColumns = [
  {
    key: "name",
    dataIndex: "name",
    title: "项目名称",
    width: "10%",
  },
  {
    key: "companyName",
    dataIndex: "companyName",
    title: "公司名称",
    width: "10%",
  },
  {
    key: "role",
    dataIndex: "role",
    title: "项目角色",
    width: "10%",
  },
  {
    key: "time",
    dataIndex: "time",
    title: "工作时间",
    width: "10%",
  },
  {
    key: "content",
    dataIndex: "content",
    title: "项目描述",
    width: "30%",
  },
];

const educationExperienceColumns = [
  {
    key: "name",
    dataIndex: "name",
    title: "学校名称",
    width: "10%",
  },
  {
    key: "education",
    dataIndex: "education",
    title: "学历",
    width: "10%",
  },
  {
    key: "educationType",
    dataIndex: "educationType",
    title: "学历",
    width: "10%",
  },
  {
    key: "time",
    dataIndex: "time",
    title: "在校时间",
    width: "10%",
  },
  {
    key: "content",
    dataIndex: "content",
    title: "在校经历",
    width: "30%",
  },
];

defineExpose({
  handleShow,
  title,
});
</script>

<template>
  <a-modal
    width="1600px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
  >
    <a-row :gutter="[12, 12]">
      <a-col :span="24">
        <a-descriptions
          style="padding-top: 10px"
          title=""
          bordered
          size="small"
          :labelStyle="{
            width: 'fit-content',
            wordBreak: 'keep-all',
          }"
        >
          <a-descriptions-item label="姓名">
            {{ formModel.realName }}
          </a-descriptions-item>
          <a-descriptions-item label="身份证">
            {{ formModel.idCard }}
          </a-descriptions-item>
          <a-descriptions-item label="生日">
            {{ formModel.birthday }}
          </a-descriptions-item>
          <a-descriptions-item label="性别">
            <template v-if="formModel.gender === 'MALE'"> 男 </template>
            <template v-else> 女 </template>
          </a-descriptions-item>
          <a-descriptions-item label="名族">
            {{ formModel.ethnic }}
          </a-descriptions-item>
          <a-descriptions-item label="手机号">
            {{ formModel.phone }}
          </a-descriptions-item>
          <a-descriptions-item label="微信号">
            {{ formModel.wechatNumber }}
          </a-descriptions-item>
          <a-descriptions-item label="电子邮箱">
            {{ formModel.email }}
          </a-descriptions-item>
          <a-descriptions-item label="求职状态">
            {{ formModel.jobSeekerStatus }}
          </a-descriptions-item>
          <a-descriptions-item label="个人优势" :span="3">
            {{ formModel.description }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="24">
        <label> 求职期望 </label>
        <a-table
          :columns="expectationColumns"
          :data-source="formModel.expectationList"
          bordered
          :pagination="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'workingType'">
              <template v-if="record[column.dataIndex] === 'FULL'">
                <a-tag color="green"> 全职 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 'PART'">
                <a-tag color="green"> 兼职 </a-tag>
              </template>
            </template>
            <template v-if="column.dataIndex === 'wage'">
              <template v-if="record['minWage'] && record['maxWage']">
                {{ record["minWage"] }} - {{ record["maxWage"] }}
              </template>
            </template>
          </template>
        </a-table>
      </a-col>
      <a-col :span="24">
        <label> 工作经历 </label>
        <a-table
          :columns="workExperienceColumns"
          :data-source="formModel.workExperienceList"
          bordered
          :pagination="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'time'">
              {{ record["beginTime"] }} - {{ record["endTime"] || "至今" }}
            </template>
          </template>
        </a-table>
      </a-col>
      <a-col :span="24">
        <label> 项目经历 </label>
        <a-table
          :columns="projectExperienceColumns"
          :data-source="formModel.projectExperienceList"
          bordered
          :pagination="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'time'">
              {{ record["beginTime"] }} - {{ record["endTime"] || "至今" }}
            </template>
          </template>
        </a-table>
      </a-col>
      <a-col :span="24">
        <label> 在校经历 </label>
        <a-table
          :columns="educationExperienceColumns"
          :data-source="formModel.educationExperienceList"
          bordered
          :pagination="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'time'">
              {{ record["beginTime"] }} - {{ record["endTime"] || "至今" }}
            </template>
            <template v-if="column.dataIndex === 'education'">
              <!--              学历：1：初中及以下；2：中专／技校：3：高中；4：大专；5：本科；6：硕士；7：博士；8：博士后-->
              <template v-if="record[column.dataIndex] === 1">
                <a-tag color="green"> 初中及以下 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 2">
                <a-tag color="green"> 中专／技校 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 3">
                <a-tag color="green"> 高中 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 4">
                <a-tag color="green"> 大专 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 5">
                <a-tag color="green"> 本科 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 6">
                <a-tag color="green"> 硕士 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 7">
                <a-tag color="green"> 博士 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 8">
                <a-tag color="green"> 博士后 </a-tag>
              </template>
            </template>
            <template v-if="column.dataIndex === 'educationType'">
              <template v-if="record[column.dataIndex] === 'FULL'">
                <a-tag color="green"> 全日制 </a-tag>
              </template>
              <template v-if="record[column.dataIndex] === 'PART'">
                <a-tag color="green"> 非全日制 </a-tag>
              </template>
            </template>
          </template>
        </a-table>
      </a-col>
      <!--      qualificationCertificateList-->
      <a-col :span="24">
        <label> 技能证书 </label>
        <br />
        <template
          v-if="
            formModel.qualificationCertificateList &&
            formModel.qualificationCertificateList.length
          "
        >
          <a-tag
            v-for="item in formModel.qualificationCertificateList"
            :key="item"
          >
            {{ item.qualificationCertificateName }}
          </a-tag>
        </template>
        <template v-else>
          <a-empty :image="simpleImage" />
        </template>
      </a-col>
    </a-row>
  </a-modal>
</template>

<style scoped lang="scss"></style>
